<script setup lang="ts">
defineProps<{
  letters: string;
  itemClass?: string | undefined;
}>();
</script>

<template lang="pug">
span.split-span-letters
  span(
    v-for="(letter, i) in letters.split('')"
    :key="`letter-${i}`"
    :class="`${itemClass} split-span-letter-${i} inline-block`")
    | {{ letter }}
</template>
